import _ from 'lodash';
import FileOutlined from '@ant-design/icons/FileOutlined';
import Button from 'antd/lib/button';
import Flex from 'antd/lib/flex';
import Space from 'antd/lib/space';
import Table, { ColumnsType } from 'antd/lib/table';
import { useState } from 'react';
import { PjmComment } from 'src/domain/pjm/dto/PjmComments';
import { PjmRegistrationDto } from 'src/domain/pjm/dto/PjmRegistrationDto';
import { RegistrationCommentModal } from './RegistrationCommentModal';
import { DEFAULT_DATE_TIME_FORMAT, getComputerFormattedTime } from 'src/domain/date/date';

interface RegistrationCommentTableProps {
    disabled?: boolean;
    value: PjmRegistrationDto['comments'];
    onChange: (value: PjmRegistrationDto['comments']) => void;
}

export function RegistrationCommentTable({ value, disabled = false, onChange }: RegistrationCommentTableProps) {
    const [showModal, setShowModal] = useState<PjmComment | null>(null);

    let comments = value?.comment?.length ? value.comment : [];
    comments = _.orderBy(comments, 'timestamp', 'desc');

    function onCommentsChange(data: PjmComment) {
        comments.push(data);

        onChange({ comment: comments });
        setShowModal(null);
    }

    function showAddCommentModal() {
        setShowModal({
            timestamp: new Date(),
        });
    }

    function onModalClose() {
        setShowModal(null);
    }

    const columns: ColumnsType<PjmComment> = [
        {
            title: 'Timestamp',
            dataIndex: 'timestamp',
            key: 'timestamp',
            minWidth: 250,
            width: 250,
            render: (text, record) => <>{getComputerFormattedTime(text, DEFAULT_DATE_TIME_FORMAT)}</>,
        },
        {
            title: 'Comment Details',
            dataIndex: 'commentDetails',
            key: 'commentDetails',
        },
        {
            title: 'Updated by',
            dataIndex: 'user',
            key: 'user',
            minWidth: 120,
            width: 120,
        },
    ];

    return (
        <Space direction="vertical" style={{ width: '100%' }}>
            <Flex style={{ width: '100%' }} justify={'space-between'} align={'center'}>
                <Button onClick={showAddCommentModal} icon={<FileOutlined />} disabled={disabled}>
                    Add Comment
                </Button>
            </Flex>

            <Table dataSource={comments} columns={columns} pagination={false} rowKey="timestamp" tableLayout={'auto'} scroll={{ x: 'scroll' }} />

            {!!showModal && (
                <RegistrationCommentModal key="pjm-registration-comment-modal" onClose={onModalClose} onChange={onCommentsChange} value={showModal} />
            )}
        </Space>
    );
}
